import { toRefs, computed } from 'vue';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    options: Object
  },
  setup(props) {
    const {
      options,
      id
    } = toRefs(props);
    const source = computed(() => {
      return id.value.replace('music.apple.com', 'embed.music.apple.com');
    });
    const height = computed(() => {
      switch (options.value.id) {
        case 'apple_track':
          return '166';
      }
      return '450';
    });
    return {
      height,
      source
    };
  }
};
export { script as default };